import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/permission';
import '@/style/common.less';
import '@/style/reset.less';
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true;
import moment from "moment";
Vue.prototype.$moment = moment;
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.use(VueClipboard);
Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
